export default __webpack_public_path__ + "static/media/smartphone-1.0825f5c6.svg";